import { makeActionCreator } from '../../redux-util/general-helpers';
import { isPanelOpen } from './middle-selectors';

export const togglePanel = makeActionCreator('ui.middle.togglePanel');
export const toggleSearch = makeActionCreator('ui.middle.toggleSearch');
export const setSearch = makeActionCreator('ui.middle.setSearch');
export const toggleReadAloud = makeActionCreator('ui.middle.toggleReadAloud');
export const setReadAloud = makeActionCreator('ui.middle.setReadAloud');
export const toggleNotesFilter = makeActionCreator(
  'ui.middle.toggleNotesFilter'
);
export const toggleBookmarksFilter = makeActionCreator(
  'ui.middle.toggleBookmarksFilter'
);
export const toggleHighlightsFilter = makeActionCreator(
  'ui.middle.toggleHighlightsFilter'
);

export function closePanel() {
  return function(dispatch, getState) {
    if (isPanelOpen(getState())) {
      dispatch(togglePanel());
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/api/redux-ui/middle/middle-actions.js